/* eslint-disable import/no-named-default */
import type { default as SentryBrowser } from '@sentry/browser';
/* eslint-disable import/no-named-default */
import type { default as SentryNative } from '@sentry/react-native';
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-function */
import { MonitoringDataClient, MonitorConfig } from '@24i/nxg-sdk-photon';
import { AnalyticsEventType } from '@24i/nxg-sdk-photon/src/analytics';

import { getEnvironment } from './utils';

export class SentryMonitoringDataClient implements MonitoringDataClient {
    private Sentry: typeof SentryBrowser | typeof SentryNative | undefined;

    constructor(props) {
        this.env = props?.monitoringEnvironment ? props?.monitoringEnvironment : 'debug';
        this.version = props?.appVersion;
        this.props = props;
    }

    name = 'sentry';

    env = 'debug';

    version = '0.1.0';

    props: any;

    async init(config: MonitorConfig): Promise<void> {
        // DSN from BS
        const { id, enabled } = config;

        if (enabled) {
            this.Sentry = (await import('./sentry')).Sentry;
            // DSN from renative.json
            const currentDsn = this.Sentry?.getCurrentHub().getClient()?.getOptions()?.dsn;

            // Override Sentry client if needed.
            // Display a warning about a mismatch between BS and renative.json configurations.
            if (currentDsn !== id) {
                console.warn(
                    'Sentry DSN mismatch between renative.json and backstage. DSN will be overriden with: ',
                    id
                );
                const appEnv = getEnvironment(this.env);
                this.Sentry?.close();
                this.Sentry?.init({
                    dsn: id,
                    environment: appEnv,
                });
            }
        } else {
            // Extra close in case there is a Sentry instance.
            this.Sentry?.close();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    async logEvent(_event: AnalyticsEventType) {
        // DO NOT log events to Sentry, use it only for exceptions
    }

    // eslint-disable-next-line class-methods-use-this
    async logException(exception, _context) {
        // TODO: map more data, ignore context for now
        this.Sentry?.captureException?.(exception);
    }
}

export const createSentryMonitoringDataClient = (runtimeConfig: unknown) =>
    new SentryMonitoringDataClient(runtimeConfig);
